import { apiEmpleo } from "../../util/ApiEmpleo";
import { TContractEmployeeValuationHistoryResponse } from "./apiListContractEmployeeValuationHistory";

// Same shape as the valuation history: date, user, old and new value.
export type TContractEndNoteHistoryResponse =
  TContractEmployeeValuationHistoryResponse;

const apiListContractEndNoteHistory = async (
  contractId: string
): Promise<TContractEndNoteHistoryResponse> => {
  const res: TContractEndNoteHistoryResponse = await apiEmpleo.get(
    `contracts/${contractId}/end-note-history`
  );

  return res;
};

export { apiListContractEndNoteHistory };
